define("calendar/components/calendar/onboarding/wizards/wrapper", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _tracking, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div
    {{did-insert this.onboardingWizardManager.validateSocialProfile}}
    {{did-update this.onboardingWizardManager.validateSocialProfile this.onboardingWizardManager.socialProfile}}
  >
    {{component
      this.onboardingWizardManager.componentName
      didUploadMedia=@didUploadMedia
      educationBoxChecked=this.educationBoxChecked
      showTrialOptInModal=@showTrialOptInModal
      socialProfile=this.onboardingWizardManager.socialProfile
      trackOnboardingStep=this.trackOnboardingStep
      transition=this.onboardingWizardManager.transition
    }}
  </div>
  */
  {
    "id": "RWFLTV29",
    "block": "[[[11,0],[4,[38,0],[[30,0,[\"onboardingWizardManager\",\"validateSocialProfile\"]]],null],[4,[38,1],[[30,0,[\"onboardingWizardManager\",\"validateSocialProfile\"]],[30,0,[\"onboardingWizardManager\",\"socialProfile\"]]],null],[12],[1,\"\\n  \"],[46,[30,0,[\"onboardingWizardManager\",\"componentName\"]],null,[[\"didUploadMedia\",\"educationBoxChecked\",\"showTrialOptInModal\",\"socialProfile\",\"trackOnboardingStep\",\"transition\"],[[30,1],[30,0,[\"educationBoxChecked\"]],[30,2],[30,0,[\"onboardingWizardManager\",\"socialProfile\"]],[30,0,[\"trackOnboardingStep\"]],[30,0,[\"onboardingWizardManager\",\"transition\"]]]],null],[1,\"\\n\"],[13]],[\"@didUploadMedia\",\"@showTrialOptInModal\"],false,[\"did-insert\",\"did-update\",\"component\"]]",
    "moduleName": "calendar/components/calendar/onboarding/wizards/wrapper.hbs",
    "isStrictMode": false
  });
  let WrapperComponent = _exports.default = (_class = class WrapperComponent extends _component2.default {
    constructor() {
      super(...arguments);
      // eslint-disable-next-line ember/no-unused-services -- used in template
      _initializerDefineProperty(this, "onboardingWizardManager", _descriptor, this);
      _initializerDefineProperty(this, "onboarding", _descriptor2, this);
      _initializerDefineProperty(this, "educationBoxChecked", _descriptor3, this);
    }
    trackOnboardingStep(eventName) {
      this.onboarding.trackOnboardingStep(eventName);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "onboardingWizardManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "onboarding", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "educationBoxChecked", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "trackOnboardingStep", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "trackOnboardingStep"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, WrapperComponent);
});